'use client';

import { HoverCardContentSlot, HoverCardTriggerSlot } from '@magicschool/spellbook/components/HoverCard/slots';
import { useSlots } from '@magicschool/spellbook/hooks/useSlots';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

type HoverCardContentProps = React.ComponentProps<typeof HoverCardPrimitive.Content>;

export type HoverCardProps = React.ComponentProps<typeof HoverCardPrimitive.Root> &
  Pick<HoverCardContentProps, 'align' | 'alignOffset' | 'className' | 'side' | 'sideOffset'>;

const HoverCardBase = ({ align, alignOffset, className, children, side, sideOffset, ...props }: HoverCardProps) => {
  const { slots } = useSlots(children, {
    trigger: { Component: HoverCardTriggerSlot },
    content: { Component: HoverCardContentSlot, props: { align, alignOffset, className, side, sideOffset } },
  });

  return (
    <HoverCardPrimitive.Root {...props}>
      {slots.trigger}
      {slots.content}
    </HoverCardPrimitive.Root>
  );
};

export const HoverCard = Object.assign(HoverCardBase, {
  Trigger: HoverCardTriggerSlot,
  Content: HoverCardContentSlot,
});

HoverCard.Trigger.displayName = 'HoverCard.Trigger';
HoverCard.Content.displayName = 'HoverCard.Content';
